import { css } from '@emotion/core';

export const InstrumentChart = css`
  height: 100%;
`;

export const errorWrapper = css`
  height: 100%;
`;
